import { checkContributorPermission } from '@repo/guards/route-checks';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/devops/deployment-integrations')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkContributorPermission(queryClient, params.organization, params.project);
        if (!(can === null || can === void 0 ? void 0 : can.can)) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/$project/devops/deployment-integrations'
                }
            });
        }
    }
});
